import styled from '@emotion/styled';
import { helperTypographyText, TypographyTextProps } from '../../../helpers';
import { exceptStyledProps } from '../../../utils';

export const TextEmotion = styled('span', exceptStyledProps('color'))<TypographyTextProps>`
  white-space: pre-line;
  ${props => helperTypographyText(props)};
`;
